import React, { useContext, useEffect, useState, useRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import Spinner from 'react-bootstrap/Spinner';
import { Link, useHistory, useLocation } from 'react-router-dom';
import {
    Row,
    Col,
    Card,
    Table,
    Modal,
    Button,
    ProgressBar,
} from "react-bootstrap";
import Moment from 'react-moment';
import swal from "sweetalert";
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactPaginate from "react-paginate";
import AddProject from '../Components/AddProject';
import { downloadProjectData, removeMultipleProjectData } from '../../../store/actions/ProjectActions';
import { getHolidayListData, AddHolidayData, updateHolidayData, updateHolidayStatusData, removeHolidayData } from '../../../store/actions/LeaveAction';
import { globalLoadingAction } from '../../../store/actions/GlobalAction';


const Holiday = (props) => {

    const dispatch = useDispatch();
    const history = useHistory();
    const startDateRef = useRef();
    const endDateRef = useRef();

    let errorsObj = { title: '', startDate: '', endDate: '' };
    const [errors, setErrors] = useState(errorsObj);

    const [title, setTitle] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [status, setStatus] = useState('');
    const [checkArray, setCheckArray] = useState([]);
    const [recId, setRecId] = useState(null);
    const [isDisabled, setIsDisabled] = useState(true);
    const [action, setAction] = useState(0);
    const [addModal, setAddModal] = useState(false);

    const chackbox = document.querySelectorAll(".checkbox-select input");
    const motherChackBox = document.querySelector("#checkAll");

    //filter
    const [searchText, setSearchText] = useState('');
    const [sordBy, setSordBy] = useState('');
    const [sort, setSort] = useState(null);
    const [pageNo, setPageNo] = useState(1);
    const [perPage, setPerPage] = useState(10);

    useEffect(() => {
        dispatch(globalLoadingAction(true));
        dispatch(getHolidayListData('', 1, perPage, props.history));
    }, []);



    const onAddProjectHandler = () => {
        setAction(1);
        setTitle('');
        setRecId(null);
        setStatus('');
        setStartDate(null);
        setEndDate(null);
        setAddModal(true);
        setIsDisabled(true);
        setCheckArray([]);
        chackbox.forEach((val, index) => {
            chackbox[index].checked = false;
        });
        motherChackBox.checked = false;
    }

    const onEditHandler = (item) => {
        let start_date = item?.start_date ? new Date(item.start_date) : new Date();
        let end_date = item?.end_date ? new Date(item.end_date) : new Date();
        setRecId(item._id);
        setStatus(item.status)
        setAction(2);
        setTitle(item.title);
        setStartDate(start_date);
        setEndDate(end_date);
        setAddModal(true);
        setIsDisabled(true);
        setCheckArray([]);
        chackbox.forEach((val, index) => {
            chackbox[index].checked = false;
        });
        motherChackBox.checked = false;
    }





    const onMultipleRemoveHandler = () => {
        swal({
            title: "Are you sure?",
            text: checkArray.length > 1 ? "You want to remove items!" : "You want to remove item!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                dispatch(globalLoadingAction(true));
                if (props.projectList.length == checkArray.length) {
                    dispatch(removeMultipleProjectData(checkArray, searchText, sordBy, sort === null ? sort ? 'asc' : 'desc' : '', pageNo - 1, perPage, props.systemAdmin, props.history));
                    setPageNo(pageNo - 1);
                } else {
                    dispatch(removeMultipleProjectData(checkArray, searchText, sordBy, sort === null ? sort ? 'asc' : 'desc' : '', pageNo, perPage, props.systemAdmin, props.history));
                }
                setIsDisabled(true);
                setCheckArray([]);
                chackbox.forEach((val, index) => {
                    chackbox[index].checked = false;
                });
                motherChackBox.checked = false;
            }
        });
    }

    const chackboxFun = (element, item) => {

        let array = [...checkArray];
        if (item === 0) {
            if (motherChackBox.checked == true) {
                props.projectList.forEach((val, index) => {
                    array.push(val._id);
                    document.querySelector(`#check${index}`).checked = true;
                });
                setIsDisabled(false);
            } else {
                props.projectList.forEach((val, index) => {
                    array = [];
                    document.querySelector(`#check${index}`).checked = false;
                });
                setIsDisabled(true);
            }

        } else {

            if (element.target.checked == true) {
                for (let x = 0; chackbox.length > x; x++) {
                    if (document.querySelector(`#check${x}`).checked == false) {
                        motherChackBox.checked = false;
                        break;
                    } else {
                        motherChackBox.checked = true;
                        setIsDisabled(false);
                    }
                }
                setIsDisabled(false);
                array.push(item._id);
            } else {
                const index = array.findIndex((val) => val === item.id);
                array.splice(index, 1);
                motherChackBox.checked = false;
                for (let x = 0; chackbox.length > x; x++) {
                    if (document.querySelector(`#check${x}`).checked == true) {
                        setIsDisabled(false);
                        break;
                    } else {
                        setIsDisabled(true);
                    }
                }
            }
        }
        setCheckArray(array);
    };

    const onDownloadHandler = () => {
        dispatch(globalLoadingAction(true));
        dispatch(downloadProjectData(checkArray, props.history));
        setIsDisabled(true);
        setCheckArray([]);
        chackbox.forEach((val, index) => {
            chackbox[index].checked = false;
        });
        motherChackBox.checked = false;
    }

    const onSearchHandler = (val) => {
        setSearchText(val);
        setSort(null);
        setSordBy('');
        const timerId = setTimeout(() => {
            dispatch(getHolidayListData(val, 1, perPage, props.history));
            setPageNo(1);
        }, 1000);
        return () => clearTimeout(timerId);
    }

    const onCleanHandler = () => {
        setSearchText('');
        setPageNo(1);
        setSort(null);
        setSordBy('');
        dispatch(globalLoadingAction(true));
        dispatch(getHolidayListData('', 1, perPage, props.history));
    }

    const handlePageClick = (data) => {
        setPageNo(data.selected + 1);
        dispatch(globalLoadingAction(true));
        dispatch(getHolidayListData(searchText, data.selected + 1, perPage, props.history));
        setSort(null);
        setSordBy('');
    };

    const onSordByHandler = (val) => {
        setSordBy(val);
        setSort(null);
    }

    const onSordHandler = () => {
        if (sordBy) {
            setSort(!sort);
            //dispatch(globalLoadingAction(true));
            //dispatch(getProjectList(searchText, sordBy, !sort ? 'asc' : 'desc', 1, perPage, props.systemAdmin, props.history));
        }
    }

    const onSubmitHandler = () => {
        let error = false;
        const errorObj = { ...errorsObj };

        if (title === '') {
            errorObj.title = 'Title is Required';
            error = true;
        }

        if (startDate === null) {
            errorObj.startDate = 'Start Date is Required';
            error = true;
        }
        if (endDate === null) {
            errorObj.endDate = 'End Date is Required';
            error = true;
        }

        setErrors(errorObj);
        if (error) {
            return;
        }
        dispatch(globalLoadingAction(true));
        if (action == 1) {
            dispatch(AddHolidayData(title, startDate ? moment(startDate).format("YYYY/MM/DD") : '', endDate ? moment(endDate).format("YYYY/MM/DD") : '', ListCallBack, props.history));
        } else {
            dispatch(updateHolidayData(recId, title, startDate ? moment(startDate).format("YYYY/MM/DD") : '', endDate ? moment(endDate).format("YYYY/MM/DD") : '', status, ListCallBack, props.history));
        }
    }

    const onStatusHandler = (item) => {
        dispatch(globalLoadingAction(true));
        dispatch(updateHolidayStatusData(item, ListCallBack));
    }

    const ListCallBack = () => {
        dispatch(getHolidayListData(searchText, pageNo, perPage, props.history));
        setAddModal(false)
    }

    const onDeleteHandler = (id) => {

        swal({
            title: "Are you sure?",
            text:
                "You want to remove this item !",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                dispatch(removeHolidayData(id, deleteCallback, props.history));
            }
        })
    }

    const deleteCallback = () => {
        if (props.holidayList.length > 1) {
            dispatch(getHolidayListData(searchText, pageNo, perPage, props.history));
        } else {
            if (pageNo == 1) {
                dispatch(getHolidayListData(searchText, 1, perPage, props.history));
                setPageNo(1);
            } else {
                dispatch(getHolidayListData(searchText, pageNo - 1, perPage, props.history));
                setPageNo(pageNo - 1);
            }

        }
    }

    return (
        <>
            <div className="row">
                <div className="breadcrumb-container">
                    <ul>
                        <li>
                            <Link to={"#"}>Leave Management</Link>
                        </li>
                        <li><i className="fa fa-angle-right"></i></li>
                        <li>
                            <Link to={"#"}>Holidays</Link>
                        </li>
                    </ul>
                </div>

                <div className="title-body-container">
                    <div className="title-body">
                        <h3>Holidays</h3>
                        <p>Maintain user information - Add, edit, delete and invite users</p>
                    </div>
                    <div className="title-filter-container">
                        <div className="search-filter">
                            <input placeholder="Search title" value={searchText} onChange={(e) => onSearchHandler(e.target.value)} />
                            <i class="fa fa-search" aria-hidden="true"></i>
                        </div>

                        {/* <div className="sort-filter">
                            <select
                                defaultValue={"option"}
                                className=""
                                value={sordBy}
                                onChange={(e) => onSordByHandler(e.target.value)}>
                                <option>Sort by</option>
                                <option value="title">Title</option>
                                <option value="start_date">Start Date</option>
                                <option value="end_date">End Date</option>
                            </select>
                            <button className={sort === null ? null : sort ? "sorting-asc" : "sorting-dec"} onClick={onSordHandler}>
                                <i class="fa fa-long-arrow-up" aria-hidden="true"></i>
                                <i class="fa fa-long-arrow-down" aria-hidden="true"></i>
                            </button>
                        </div> */}
                        {props.systemAdmin ?
                            <div className="button-filter">
                                <button className="add-user-btn"
                                    onClick={() => onAddProjectHandler()}><i class="fa fa-plus" aria-hidden="true"></i></button>
                            </div>
                            : null}
                    </div>

                </div>
                <div className="account-setting-content">
                    <Col lg={12}>
                        <Card>
                            {/* <Card.Header>
                                <div className="add-role-button-view">
                                    <div className="add-btn-group">
                                        <button disabled={isDisabled}><i class="fa fa-external-link" aria-hidden="true"></i></button>
                                        <button
                                            onClick={() => onMultipleRemoveHandler()}
                                            disabled={isDisabled}>X</button>
                                        <button disabled={isDisabled}>S</button>
                                        <button
                                            onClick={() => onDownloadHandler()}
                                            disabled={isDisabled}>
                                            <i class="fa fa-download" aria-hidden="true"></i></button>
                                    </div>
                                </div>
                            </Card.Header> */}
                            <Card.Body>
                                {props.screenVisible ?
                                    <>
                                        {props.holidayList.length > 0 ?
                                            <Table responsive>
                                                <thead>
                                                    <tr>
                                                        {/* <th className="customer_shop">
                                                            <div className="form-check custom-checkbox mx-2">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    id="checkAll"
                                                                    onClick={(e) => chackboxFun('all', 0)}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="checkAll"
                                                                ></label>
                                                            </div>
                                                        </th> */}

                                                        <th>
                                                            <strong>Title</strong>
                                                        </th>
                                                        <th>
                                                            <strong>Start Date</strong>
                                                        </th>
                                                        <th>
                                                            <strong>End Date</strong>
                                                        </th>
                                                        {props.systemAdmin ?
                                                            <th>
                                                                <strong>Create Date</strong>
                                                            </th> : null}
                                                        <th>
                                                            <strong>Status</strong>
                                                        </th>
                                                        {props.systemAdmin ?
                                                            <th>
                                                                <strong>Actions</strong>
                                                            </th> : null}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        props.holidayList.map((item, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    {/* <td>
                                                                        <div className="form-check custom-checkbox checkbox-select mx-2">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id={`check${index}`}
                                                                                onClick={(e) => chackboxFun(e, item)}
                                                                            />
                                                                            <label
                                                                                className="form-check-label"
                                                                                htmlFor={`check${index}`}
                                                                            ></label>
                                                                        </div>
                                                                    </td> */}
                                                                    <td>{item.title}</td>
                                                                    <td><Moment format="D MMM YYYY" withTitle>{item.start_date}</Moment></td>
                                                                    <td><Moment format="D MMM YYYY" withTitle>{item.end_date}</Moment></td>
                                                                    {props.systemAdmin ? <td><Moment format="D MMM YYYY" withTitle>{item.created_at}</Moment></td> : null}
                                                                    <td>
                                                                        {props.systemAdmin ?
                                                                            <Button
                                                                                className="btn-xs"
                                                                                variant={item.status == 1 ? "success" : "danger"}
                                                                                onClick={() => onStatusHandler(item)}
                                                                            >
                                                                                {item.status == 1 ? "Active" : "Inactive"}
                                                                            </Button> : <Button
                                                                                className="btn-xs"
                                                                                variant={item.status == 1 ? "success" : "danger"}
                                                                            >
                                                                                {item.status == 1 ? "Active" : "Inactive"}
                                                                            </Button>}
                                                                    </td>
                                                                    {props.systemAdmin ?
                                                                        <td>
                                                                            <div className="d-flex">
                                                                                <Link
                                                                                    onClick={() => onEditHandler(item)}
                                                                                    className="btn btn-warning shadow btn-xs sharp me-1"
                                                                                >
                                                                                    <i className="fas fa-pencil-alt"></i>
                                                                                </Link>

                                                                                <Button
                                                                                    className="btn btn-danger shadow btn-xs sharp me-1"
                                                                                    onClick={() => onDeleteHandler(item._id)}
                                                                                >
                                                                                    <i className="fa fa-trash"></i>
                                                                                </Button>

                                                                            </div>
                                                                        </td> : null}
                                                                </tr>
                                                            );
                                                        })
                                                    }
                                                </tbody>
                                            </Table>
                                            :
                                            <div className="nodata-found-view">
                                                <h2>Data not found</h2>
                                                <p>Holiday is empty or Try again search</p>
                                                <button type="button" onClick={onCleanHandler}>
                                                    Retry
                                                </button>
                                            </div>
                                        }
                                    </>
                                    : null}

                                <div className="pagination-container">
                                    {parseInt(props.totalRecord) > 0 && props.showLoading == false ? (
                                        <div className="page-result alignResult">
                                            <p>Showing{" "}{(pageNo - 1) * perPage + 1 + " - " + ((pageNo - 1) * perPage + props.holidayList.length) + " of " + "( " + props.totalRecord + " items )"}</p>
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}

                                    {parseInt(props.totalRecord) > 10 ? (
                                        <ReactPaginate
                                            containerClassName="pagination-gutter false pagination-circle pagination"
                                            pageClassName="page-item"
                                            pageLinkClassName="page-link"
                                            breakLabel="..."
                                            nextLabel={<i class="fa fa-angle-right" aria-hidden="true"></i>}
                                            nextClassName="page-item"
                                            nextLinkClassName="page-link"
                                            previousLabel={<i class="fa fa-angle-left" aria-hidden="true"></i>}
                                            previousClassName="page-item"
                                            previousLinkClassName="page-link"
                                            breakClassName="page-item"
                                            breakLinkClassName="page-link"
                                            renderOnZeroPageCount={null}
                                            activeClassName="active"
                                            onPageChange={handlePageClick}
                                            pageRangeDisplayed={3}
                                            pageCount={props.totalPage}
                                            //initialPage={active - 1}
                                            forcePage={pageNo - 1}
                                        />
                                    ) : null}
                                </div>

                            </Card.Body>
                        </Card>
                    </Col>
                </div>


                <Modal
                    className="fade bd-example-modal-sm"
                    size="md"
                    show={addModal}
                >
                    <div className="add-user-modal-form-view">
                        <div className="modal-title-view">
                            <h3>{action == 1 ? "Add" : "Update"} Holiday</h3>
                        </div>
                        <div className="basic-form">

                            <div className="row">

                                <div className="form-group form-group-modal-custom mb-3 col-12">
                                    <label className="mb-1">
                                        Title
                                    </label>
                                    <input className="form-control" value={title} onChange={(e) => setTitle(e.target.value)} />
                                    {errors.title && <div className="text-danger fs-12">{errors.title}</div>}
                                </div>


                                <div className="form-group form-group-modal-custom mb-3 col-6">
                                    <label className="mb-1">
                                        Start Date
                                    </label>
                                    <div className="form-calendar">
                                        <DatePicker
                                            ref={startDateRef}
                                            selected={startDate}
                                            className="form-control"
                                            placeholderText=""
                                            onChange={(date) => setStartDate(date)}
                                        />
                                        <button type='button' className="form-calendar-btn"
                                            onClick={() => startDateRef.current.setOpen(true)}
                                        >
                                            <i class="fa-regular fa-calendar-days"></i>
                                        </button>
                                    </div>
                                    {errors.startDate && <div className="text-danger fs-12">{errors.startDate}</div>}
                                </div>

                                <div className="form-group form-group-modal-custom mb-3 col-6">
                                    <label className="mb-1">
                                        End Date
                                    </label>
                                    <div className="form-calendar">
                                        <DatePicker
                                            ref={endDateRef}
                                            selected={endDate}
                                            className="form-control"
                                            placeholderText=""
                                            onChange={(date) => setEndDate(date)}
                                        />
                                        <button type='button' className="form-calendar-btn"
                                            onClick={() => endDateRef.current.setOpen(true)}
                                        >
                                            <i class="fa-regular fa-calendar-days"></i>
                                        </button>
                                    </div>
                                    {errors.endDate && <div className="text-danger fs-12">{errors.endDate}</div>}
                                </div>

                                {/* <div className="col-md-6 mb-3">
                                    <div className="form-view-info">
                                        <h3>Status : <span>{status == 1 ? 'Active' : 'Inactive'}</span></h3>
                                    </div>
                                </div> */}

                            </div>

                            <div className="modal-button-group mt-4">
                                <button type="button" onClick={() => setAddModal(false)} className="btn form-cencel-btn">
                                    Close
                                </button>
                                <button type="button" className="btn btn-primary role-form-btn" onClick={() => onSubmitHandler()}>
                                    {action == 1 ? "Submit" : "Update"}
                                </button>
                            </div>

                        </div>

                    </div>
                </Modal>



            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        screenVisible: state.leave.screenVisible,
        showLoading: state.leave.showLoading,
        holidayList: state.leave.holidayList,
        totalPage: state.leave.totalPage,
        totalRecord: state.leave.totalRecord,
        systemAdmin: state.auth.systemAdmin,
        userType: state.auth.userType,
    };
};
export default connect(mapStateToProps)(Holiday);